import classNames from 'classnames';
import { List } from 'yoso';
import { useChallengeRewards } from '~/components/Challenge/Purchase/ChallengePurchase.hooks';
import { ChallengePurchaseItem } from '~/components/Challenge/Purchase/Item/ChallengePurchaseItem';
import { BaseError } from '~/components/Error/BaseError';
import styles from './ChallengePurchaseList.module.scss';
export type ChallengePurchaseListProps = {
  eventId?: number;
  className?: string;
};

export const ChallengePurchaseList = ({ eventId, className }: ChallengePurchaseListProps) => {
  const {
    data: { histories: items },
    isFetching,
    isFetched,
  } = useChallengeRewards(eventId);

  if (isFetched && items.length === 0) throw new BaseError('EMPTY');

  return (
    <List
      className={classNames(
        styles.root,
        { [styles.loading]: isFetching, [styles.initial]: !isFetched },
        className
      )}>
      {items.map((item, i) => (
        <li key={i}>
          <ChallengePurchaseItem {...item} />
        </li>
      ))}
    </List>
  );
};
